<div class="px-1" *ngIf="permissionData$ | async as permissionData">
    <div class="tab-body">
        <div class="button-wrapper">
            <app-button name="Tag Item-Vendor" type="flat-button" tabindex="0"
                (keypress)="(!isReadOnly && isAssignedPEAndNotReadied && !isLocked) && onTagItemVendorButtonClick()"
                (click)="(!isReadOnly && isAssignedPEAndNotReadied && !isLocked) && onTagItemVendorButtonClick()"
                [disabled]="!isAssignedPEAndNotReadied || isLocked"></app-button>
        </div>
        <div class="section--item-sourcing mt-3">
            <mat-expansion-panel expanded="true" togglePosition="before">
                <mat-expansion-panel-header>
                    <mat-panel-title>Items Sourcing Outcome</mat-panel-title>
                </mat-expansion-panel-header>

                <ng-container
                    *ngIf="form && form.ItemList && form.ItemList.length > 0; else itemSourcingNoResultsTemplate">
                    <mat-form-field class="custom-table-filter">
                        <mat-label><mat-icon>filter_list</mat-icon>Filter by keyword e.g. Purchase Executive, Sourcing
                            Status
                            Tagged</mat-label>
                        <input matInput (keyup)="applyItemSourcingFilter($event)" #itemSourcingInput>
                    </mat-form-field>
                    <div class="custom-table-wrapper--inner">
                        <table class="mat-elevation-z3 table-content" mat-table multiTemplateDataRows
                            #itemSourcingTableSort="matSort" matSort [dataSource]="itemSourcingDataSource">
                            <ng-container matColumnDef="{{ column }}" *ngFor="let column of itemSourcingDisplayColumns">
                                <div *ngIf="column === 'itemNumber'">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Item No.</th>
                                </div>
                                <div *ngIf="column === 'itemDescription'">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Item Description</th>
                                </div>
                                <div *ngIf="column === 'vendorTagged'">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Vendor Tagged</th>
                                </div>
                                <div *ngIf="column === 'purchaseExecutiveName'">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Purchase Executive</th>
                                </div>
                                <div *ngIf="column === 'sourcingStatus'">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Sourcing Status</th>
                                </div>

                                <div>
                                    <td mat-cell *matCellDef="let element"
                                        [ngClass]="{'text--grey': element[column] === 'Not yet selected'}">{{
                                        element[column] }}</td>
                                </div>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="itemSourcingDisplayColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: itemSourcingDisplayColumns;">
                            </tr>
                            <!-- Row shown when there is no matching data -->
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="100%" *ngIf="itemSourcingDataSource.data.length > 0">No
                                    data matching the filter
                                    "{{itemSourcingInput.value}}"</td>
                            </tr>
                        </table>
                    </div>
                    <mat-paginator #itemSourcingPaginator [pageSize]="defaultItemSourcingPageSize"
                        (page)="onItemSourcingPaginatorPage($event)" [pageSizeOptions]="pageSizeOptions"
                        showFirstLastButtons class="custom-table-paginator"></mat-paginator>
                </ng-container>
            </mat-expansion-panel>
        </div>

        <div class="section--tagged mt-3">

            <mat-expansion-panel expanded="true" togglePosition="before">
                <mat-expansion-panel-header>
                    <mat-panel-title>Tagged Item-Vendor</mat-panel-title>
                </mat-expansion-panel-header>
                <ng-container *ngIf="tagItemVendorService.taggedGroups$ | async as taggedGroupsObj">
                    <ng-container
                        *ngIf="tagItemVendorService.getActiveTaggedGroups(taggedGroupsObj.taggedGroups).length > 0; else taggedNoResultsTemplate">
                        <mat-form-field class="custom-table-filter">
                            <mat-label><mat-icon>filter_list</mat-icon>Filter by keyword e.g. Purchase Executive
                                Set</mat-label>
                            <input matInput (keyup)="applyTaggedItemVendorFilter($event)" #taggedItemVendorInput>
                        </mat-form-field>
                        <div class="custom-table-wrapper--inner">

                            <table class="mat-elevation-z3 table-content" mat-table multiTemplateDataRows
                                #taggedItemVendorTableSort="matSort" matSort [dataSource]="taggedItemVendorDataSource">
                                <ng-container matColumnDef="{{ column }}"
                                    *ngFor="let column of taggedItemVendorDisplayColumns">
                                    <div *ngIf="column === 'purchaseExecutiveName'">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Purchase Executive</th>
                                    </div>
                                    <div *ngIf="column === 'itemNumberSet'">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Item No. Set</th>
                                    </div>
                                    <div *ngIf="column === 'vendorSet'">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Vendor Set</th>
                                    </div>
                                    <div *ngIf="column === 'sourcingStatus'">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Sourcing Status</th>
                                    </div>
                                    <div *ngIf="column === 'action'">
                                        <th mat-header-cell *matHeaderCellDef class="table-cell--freeze-right">Action
                                        </th>
                                    </div>
                                    <div *ngIf="column === 'action'">
                                        <td mat-cell *matCellDef="let element"
                                            class="table-cell--freeze-right custom-table-icon-buttons">
                                            <ng-container
                                                *ngIf="isAssignedPEAndNotReadied && !isLocked && element.purchaseExecutive === loggedInUsername; else taggedDisabledActionButtons">
                                                <button (click)="onEditTaggedGroupClick(element.taggedGroup)"
                                                    type="button"><mat-icon>edit</mat-icon></button>
                                                <button
                                                    (click)="tagItemVendorService.deleteTaggedGroup(element.taggedGroup)"
                                                    type="button"><mat-icon>delete</mat-icon></button>
                                            </ng-container>
                                        </td>
                                    </div>
                                    <div *ngIf="!['action'].includes(column)">
                                        <td mat-cell *matCellDef="let element"
                                            [ngClass]="{'text--grey': element[column] === 'Not yet selected'}">{{
                                            element[column] }}</td>
                                    </div>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="taggedItemVendorDisplayColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: taggedItemVendorDisplayColumns;">
                                </tr>
                                <tr class="mat-row" *matNoDataRow>
                                    <td class="mat-cell" colspan="100%"
                                        *ngIf="taggedItemVendorDataSource.data.length > 0">No data matching the filter
                                        "{{taggedItemVendorInput.value}}"</td>
                                </tr>
                            </table>
                        </div>
                        <mat-paginator #taggedItemVendorPaginator [pageSize]="defaultTaggedItemVendorPageSize"
                            (page)="onTaggedItemVendorPaginatorPage($event)" [pageSizeOptions]="pageSizeOptions"
                            showFirstLastButtons class="custom-table-paginator"></mat-paginator>
                    </ng-container>
                </ng-container>
            </mat-expansion-panel>
        </div>
    </div>
</div>

<ng-template #tooltipTemplateDisableTaggedActions>
    <div class="custom-tooltip">
        <p class="paragraph-small-regular">
            You cannot edit this record as you are not the Purchasing Executive in charge of this item.
        </p>
    </div>
</ng-template>

<ng-template #taggedDisabledActionButtons>
    <div [tp]="tooltipTemplateDisableTaggedActions" tpClassName="custom-tooltip" tpMaxWidth="200px"
        [tpInteractive]="true" tpPlacement="bottom" class="custom-table-icon-buttons">
        <button disabled><mat-icon>edit</mat-icon></button>
        <button disabled><mat-icon>delete</mat-icon></button>
    </div>
</ng-template>

<ng-template #itemSourcingNoResultsTemplate>
    <app-add-reference-card [desc]="'No item requiring sourcing found.'">
    </app-add-reference-card>
</ng-template>
<ng-template #taggedNoResultsTemplate>
    <app-add-reference-card [desc]="'You have not tagged any item and vendor yet.'">
    </app-add-reference-card>
</ng-template>